import Slider from "react-slick";
import "./BannerSlider.css";
import React from "react";

// 👇 your slider settings
const settings = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 992, // tablet
      settings: { dots: false, speed: 600 },
    },
    {
      breakpoint: 576, // mobile
      settings: { dots: false, autoplaySpeed: 3000 },
    },
  ],
};

const BannerSlider = ({ bannerImages }) => {
  // track loading for each image
  const [loaded, setLoaded] = React.useState({});

  const handleImageLoad = (index) => {
    setLoaded((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <div className="banner-slider-container" id="home">
      <Slider {...settings}>
        {bannerImages.map((v, index) => (
          <div className="banner-slide" key={index}>
            {!loaded[index] && (
              <div className="img-loader">
                <div className="spinner"></div>
              </div>
            )}
            <img
              className={`banner-mn-img ${loaded[index] ? "visible" : "hidden"}`}
              src={v.imageUrl}
              alt={`Banner Img ${index + 1}`}
              onLoad={() => handleImageLoad(index)}
              onError={() => handleImageLoad(index)}
              loading="lazy"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BannerSlider;

// import Slider from "react-slick";
// import "./BannerSlider.css"; // 👈 external CSS

// const settings = {
//   dots: true,
//   infinite: true,
//   speed: 800,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   arrows: false,
//   pauseOnHover: true,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: { dots: false, speed: 600 },
//     },
//     {
//       breakpoint: 576,
//       settings: { dots: false, autoplaySpeed: 3000 },
//     },
//   ],
// };

// const BannerSlider = ({ bannerImages }) => {
//   console.log(bannerImages);

//   return (
//     <div style={{ width: "100%", overflow: "hidden" }}>
//       <style>
//         {`
//           .banner-slide {
//             position: relative;
//             width: 100%;
//           }
//           .banner-slide img {
//             width: 100%;
//             height: auto; /* keeps aspect ratio */
//             display: block;
//           }
//           @media (min-width: 993px) {
//             .banner-slide {
//               height: 600px;
//             }
//             .banner-slide img {
//               height: 600px;
//               object-fit: cover;
//             }
//           }
//           @media (max-width: 992px) and (min-width: 577px) {
//             .banner-slide {
//               height: 450px;
//             }
//             .banner-slide img {
//               height: 450px;
//               object-fit: cover;
//             }
//           }
//           @media (max-width: 576px) {
//             .banner-slide {
//               height: 280px;
//             }
//             .banner-slide img {
//               height: 280px;
//               object-fit: cover;
//             }
//           }
//         `}
//       </style>

//       <Slider {...settings}>
//         {bannerImages.map((v, index) => (
//           <div className="banner-slide" key={index}>
//             <img src={v.imageUrl} alt={`Banner ${index + 1}`} />
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default BannerSlider;
